import Svg, { Circle, G, Path, SvgProps } from 'react-native-svg';

import Colors from '@lib/constants/Colors';

type CloseProps = {
    hideCircle?: boolean;
} & SvgProps;

function Close({ hideCircle, ...props }: CloseProps): JSX.Element {
    return (
        <Svg
            width={props.width || 27.456}
            height={props.height || 27.456}
            viewBox="0 0 27.456 27.456"
            {...props}
        >
            <G
                data-name="Group 68"
                transform="translate(-2 -2)"
                fill="none"
                stroke={props.color || Colors['secondary.dark']}
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
            >
                {!hideCircle && (
                    <Circle
                        data-name="Ellipse 28"
                        cx={12.728}
                        cy={12.728}
                        r={12.728}
                        transform="translate(3 3)"
                        stroke={props.color || Colors['primary.dark']}
                        fill="#fff"
                    />
                )}
                <Path data-name="Line 22" d="M19.97 19.97l-8.485-8.485" />
                <Path data-name="Line 23" d="M19.97 11.485l-8.485 8.485" />
            </G>
        </Svg>
    );
}

export default Close;
